import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import * as fromRootStore from "../..//reducers";
import { ExcelService, ReportService } from "../..//services/index";
declare var google;

@Component({
  selector: "purchaseOrder",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./seasonWiseValueAnnualReport.html"
})
export class seasonWiseValueAnnualReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  typeList = ["Wholesale", "Retail", "Estimate"];
  gridOptions: any;
  dataList = [];
  qualityList: any;
  colorList: any;
  codeList: any;
  widthList: any[];
  brandList: any[];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  finyearList = [];
  agentParty = [
    {
      type: ""
    },
    {
      type: ""
    }
  ];
  exceldata: any;
  groupbyList = ["DESIGN NO", "WO NO"];
  filter: any = {
    type: "",
    finyear: "",
    season: "",
    agentPartyType: "PARTYWISE",
    agent_id: "",
    annual_season_id: ""
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "party_name",
    orderDir: "asc"
  };
  printConfig: any = {
    title: "Season Wise Annual Comparision Report",
    columns: [],
    rows: []
  };

  partyList = [];
  @ViewChild("filterPanel") filterPanel;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  columns = [];
  partycodeList = [];
  annualSeason = [];
  toggleCol = [];
  menu: any;
  reportTypeList = ["DESIGN NO", "PARTY", "PURCHASE"];
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  swatchList = ["YES", "NO"];
  sampList = ["YES", "NO"];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  row: any;
  curDate = "";
  curYear = new Date();
  currentYear = this.curYear.getFullYear();
  currFrom: string;
  eaFrom;
  preFrom: string;
  constructor(
    public store: Store<fromRootStore.State>,
    private excelService: ExcelService,
    public datePipe: DatePipe,
    private reportService: ReportService,
    public toasterService: ToasterService,
  ) {}

  ngOnInit(): void {
    this.getColumns();
    this.agentPartytype();
    this.dynamicFinancilaYear();
    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        type: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        sortable: false,
        toggle: true,
        cellClass: "text-center",
        headerClass: "text-center"
      },
      {
        name: "F/S",
        prop: "ftot",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center"
      },
      {
        name: "H/S",
        prop: "htot",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center"
      },
      {
        name: "GR.Tot",
        prop: "gr_tot",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center"
      },
      {
        name: "F/S",
        prop: "ftot",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center"
      },
      {
        name: "H/S",
        prop: "htot",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center"
      },
      {
        name: "GR.Tot",
        prop: "gr_tot",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center"
      },
      {
        name: "F/S",
        prop: "ftot",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center"
      },
      {
        name: "H/S",
        prop: "htot",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center"
      },
      {
        name: "GR.Tot",
        prop: "gr_tot",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center"
      }
    ];

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: []
    };
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    setTimeout(function() {
      $("#party_code").focus();
    }, 100);
  }
  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.loadSeasonList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  dynamicFinancilaYear() {
    var dt = new Date();
    this.curDate =
      dt.getFullYear() + "-" + (dt.getMonth() + 1) + "-" + dt.getDate();

    if (this.curDate < this.currentYear + "-04-01") {
      this.currentYear = this.curYear.getFullYear() - 1;
    } else {
      this.currentYear = this.curYear.getFullYear();
    }

    this.currFrom = this.currentYear + "-" + (this.currentYear + 1);

    this.preFrom = this.currentYear - 1 + "-" + this.currentYear;

    this.eaFrom = this.currentYear - 2 + "-" + (this.currentYear - 1);
  }
  applyFilter(): void {
    let anuualSeasonId = _.filter(this.annualSeason, {
      season: this.filter.season
    });

    this.filter.annual_season_id = anuualSeasonId[0].annual_season_id;
    this.getReport();
  }
  onCellClick(event) {
    this.filter.agent_id = event.row.id;

    this.getReport();
  }
  onbackbutton() {
    this.filter.agent_id = "";
  }

  agentPartytype() {
    this.agentParty = [
      {
        type: "PARTYWISE"
      },
      {
        type: "AGENTWISE"
      }
    ];
  }

  getReport(): void {
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      filter: JSON.stringify(this.filter),
      agentPartyType: this.filter.agentPartyType,
      season: this.filter.season
    };
    let that = this;
    that.gridOptions = {
      loading: true,
      columns: []
    };
    this.isLoadMask = this.reportService
      .getseasonwiseValueAnnualReport(params)
      .then(function(res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.orderList = res.data;
        that.gridOptions = {
          cols: res.cols,
          columns: res.columns,
          data: res.data,
          loading: false
        };

        that.exceldata = that.getData(res.columns, res.data);
      });
  }
  loadSeasonList() {
    let that = this;
    that.reportService.getBrandNewSeason(this.filter).then(function(res) {
      that.seasonList = res;

      that.annualSeason = that.seasonList.reduce((list, li) => {
        if (
          !list.find(
            x =>
              x.annual_season_id === li.annual_season_id &&
              x.season === li.season
          )
        ) {
          list.push(li);
        }
        return list;
      }, []);
      that.filter.season =
        that.annualSeason[that.annualSeason["length"] - 1].season;
      that.applyFilter();
    });
  }

  getData(columns, data) {
    let cols = columns;
    // let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < rlen; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/salesReports/seasonWiseValueAnnualReport.ts